// extracted by mini-css-extract-plugin
module.exports = {"search-bar-wrap":"list_style_search-bar-wrap__3ORB0","table-wrap":"list_style_table-wrap__2GUIA"};